import React, { useContext } from "react";
import UserContext from "../contexts/userContext";

type Props = {
	amount: number;
	currency: string;
	locale?: string;
};

const Currency = ({ amount, currency, locale = null }: Props) => {
	const { profile } = useContext(UserContext);
	const lang = locale ? locale : profile.language; //navigator.language;

	currency = currency.toUpperCase();

	return <>{new Intl.NumberFormat(lang, { style: "currency", currency }).format(amount)}</>;
};

export default Currency;
